import { render } from "./InvoicePage.vue?vue&type=template&id=3a77d8f1"
import script from "./InvoicePage.vue?vue&type=script&lang=js"
export * from "./InvoicePage.vue?vue&type=script&lang=js"

import "./InvoicePage.vue?vue&type=style&index=0&id=3a77d8f1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__